import { useEffect, useState } from 'react'
import { useTitle } from '../../../hooks/useTitle'
import * as S from './styles'
import { useInfiniteScroll } from '../../../hooks/useInfiniteScroll'
import { useSearch } from '../../../context/SearchContext'
import CatalogProductCard from '../../../components/ChatbotCatalog/CatalogProductCard'
import Loading from '../../../commons/Loading'
import EmptyPage from '../../../components/EmptyPage'
import CatalogCart from '../../../components/ChatbotCatalog/CatalogCart'
import CatalogBackToTop from '../../../components/ChatbotCatalog/CatalogBackToTop'
import CatalogBreadcrumb from '../../../components/ChatbotCatalog/CatalogBreadcrumb'

const CatalogSearch = () => {
  const {
    search,
    products,
    requestSearchInfinite,
    currentPage,
    totalPages,
  } = useSearch();

  const [isLoading, setIsLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);

  useEffect(() => {
    const firstRequest = async () => {
      await requestSearchInfinite(1)
    }

    firstRequest()
  }, []);

  const loadMore = async () => {
    setIsLoading(true)
    if (hasMore) {
      await requestSearchInfinite(currentPage + 1);
    }
    setIsLoading(false)
  };

  const loaderRef = useInfiniteScroll({
    onEndReached: loadMore,
    isLoading,
    hasMore,
  });

  useEffect(() => {
    if ((search && currentPage > 0 && totalPages > 0 && currentPage >= totalPages) || products.length === 0) {
      setHasMore(false);
    } else {
      setHasMore(true);
    }
  }, [search, currentPage, totalPages, products]);

  useTitle(`Busca por ${search || '...'}`);

  return (
    <S.CategoryDetail>
      <CatalogBreadcrumb
        parent={`Busca por "${search}"`}
      />
      {
        products.length > 0
        ? <S.CategoryGridProducts>
            {products.map((product) => (
                <CatalogProductCard key={product.id} product={product} isCategoryPage />
              ))
            }
          </S.CategoryGridProducts>
        : <EmptyPage message="Nenhum produto encontrado" />
      }
      <CatalogCart />
      <div ref={loaderRef} style={{ height: '1px' }} />
      {isLoading && (
        <S.LoadingWrapper>
          <Loading />
        </S.LoadingWrapper>
      )}
      <CatalogBackToTop />
    </S.CategoryDetail>
  );
};

export default CatalogSearch
